
export const PrivacyPolicy = () => {
    return (
        <div className="max-w-3xl mx-auto py-12 px-6">
            <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
            <div className="prose prose-zinc max-w-none text-zinc-600">
                <p>Last updated: January 2026</p>
                <h3>1. Introduction</h3>
                <p>Welcome to Versarc. We respect your privacy and are committed to protecting your personal data.</p>

                <h3>2. Data We Collect</h3>
                <p>We collect personal data such as your name, email, phone number, and shipping address when you place an order or create an account.</p>

                <h3>3. How We Use Your Data</h3>
                <p>We use your data to process orders, deliver products, and improve our services.</p>

                <h3>4. Data Security</h3>
                <p>We implement appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way.</p>
            </div>
        </div>
    );
};

export const TermsOfService = () => {
    return (
        <div className="max-w-3xl mx-auto py-12 px-6">
            <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
            <div className="prose prose-zinc max-w-none text-zinc-600">
                <p>Last updated: January 2026</p>
                <h3>1. Acceptance of Terms</h3>
                <p>By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.</p>

                <h3>2. Operations</h3>
                <p>We reserve the right to modify or discontinue service to anyone for any reason at any time.</p>

                <h3>3. Orders & Billing</h3>
                <p>We reserve the right to refuse any order you place with us. In the event that we make a change to or cancel an order, we may attempt to notify you.</p>

                <h3>4. Liability</h3>
                <p>We are not liable for any harm or damages related to the purchase or use of goods, services, resources, content, or any other transactions made in connection with any third-party websites.</p>
            </div>
        </div>
    );
};
